module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid29_800x1067.7e5900a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid29_800x1067.jpg
// module id = IdN6
// module chunks = 0